import { useState, useEffect, useRef } from 'react';

import styled from 'styled-components';

import { useWindowDimensions } from '@hooks/use-window-dimensions';

export const FixedBottomActions = ({ children }) => {
  const [actionsHeight, setActionsHeight] = useState(0);
  const [container, setContainer] = useState(undefined);
  const { width } = useWindowDimensions();
  const containerRef = useRef(null);
  const actionsRef = useRef(null);

  useEffect(() => {
    const containerRect = containerRef.current?.getBoundingClientRect();
    setContainer(containerRect);

    const actionsRect = actionsRef.current?.getBoundingClientRect();
    setActionsHeight(actionsRect?.height ?? 0);
  }, [width]);

  return (
    <>
      <ActionsSpacer height={actionsHeight} />
      <Container ref={containerRef}>
        <Actions
          ref={actionsRef}
          paddingLeft={container?.left}
          paddingRight={width - container?.right}
        >
          {children}
        </Actions>
      </Container>
    </>
  );
};

const Container = styled.div({});

const ActionsSpacer = styled.div((p) => ({
  position: 'relative',
  minHeight: p.height,
  maxHeight: p.height,
  height: p.height,
  width: '100%',
}));

export const Actions = styled.div((p) => ({
  position: 'fixed',
  transition: 'left 150ms ease-out',
  paddingLeft: p.paddingLeft,
  paddingRight: p.paddingRight,
  paddingTop: '1.5rem',
  paddingBottom: '1.5rem',
  bottom: 0,
  left: 0,
  right: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#fff',
  boxShadow: 'inset 0 2px 0 0 rgba(255, 255, 255, 0.3), 0 2px 5px 0 rgba(0, 0, 0, 0.1)',
  '> *:not(:first-child)': {
    marginLeft: 10,
  },
  '@media (max-width: 768px)': {
    flexDirection: 'column',

    '> *:not(first-child)': {
      marginLeft: 0,
      marginBottom: 10,
      width: '100%',
      maxWidth: 500,
    },
  },
  [p.theme.mobileQuery]: {
    left: 0,
  },
}));
